import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { targetsFetchItem } from './targetsFetchItem';

import { ITargetsStore } from '../../types';
import { IActionTargetsFetchItemPayloadDone } from './types';

export const targetsFetchItemReducer = (projects: ReducerBuilder<ITargetsStore, ITargetsStore>) => {
	applyAsyncReducer<ITargetsStore['target']['data'], ITargetsStore['target']['meta']>()(
		'target',
		'networkStatus',
		targetsFetchItem.async,
		projects,
		(props: { result: IActionTargetsFetchItemPayloadDone }) => ({
			target: props.result.target,
			plan: props.result.plan,
		}),
	);
};
